export interface CategoryItem {
  key: string;
  name: string;
  desc: string;
  count: number;
  icon: string;
}

export const categories: CategoryItem[] = [
  { key: "ent", name: "影视娱乐", desc: "剧综首映、红毯名场面、圈内新瓜集中围观", count: 1286, icon: "ri-film-line" },
  { key: "sport", name: "体坛赛场", desc: "赛事战报、冠军悬念、高光瞬间逐帧复盘", count: 864, icon: "ri-trophy-line" },
  { key: "music", name: "音乐现场", desc: "演唱会票务、阵容官宣、现场名场面回顾", count: 632, icon: "ri-radio-line" },
  { key: "tech", name: "数码科技", desc: "新品发布会、参数对比、真机上手实测", count: 519, icon: "ri-smartphone-line" },
  { key: "social", name: "社会现场", desc: "城市热点、烟火日常、值得蹲的故事", count: 745, icon: "ri-earth-line" },
  { key: "food", name: "吃瓜研究所", desc: "催更套路、围观手册、防走失指南", count: 288, icon: "ri-focus-2-line" },
];

export interface StepItem {
  index: string;
  title: string;
  desc: string;
  icon: string;
}

export const steps: StepItem[] = [
  { index: "01", title: "找对指路牌", desc: "不知道瓜从哪吃起？按分类与关键词一搜即达，热门事件入口清晰不迷路。", icon: "ri-compass-3-line" },
  { index: "02", title: "蹲好后续位", desc: "一键收藏正在更新的围观帖，脉络按时间线自动串联，往前翻也跟得上进度。", icon: "ri-time-line" },
  { index: "03", title: "大方催更", desc: "想早点看到进展？点个催更，整理的同学就会优先把下一段脉络补上。", icon: "ri-bubble-chart-line" },
  { index: "04", title: "提醒不漏更", desc: "关注的事件有新进展，第一时间推给你。跟紧大部队，精彩片段不错过。", icon: "ri-notification-3-line" },
];

export interface Testimonial {
  name: string;
  role: string;
  content: string;
  star: number;
  color: string;
}

export const testimonials: Testimonial[] = [
  { name: "追剧第一名", role: "蹲后续 87 天", content: "以前总怕断更，现在把线索都串成时间线，脉络清清楚楚，跟着更新追完全程特别省心。", star: 5, color: "bg-primary-500" },
  { name: "球场小喇叭", role: "催更 12 次", content: "决赛那晚蹲更新蹲到半夜，哨声一响脉络马上补齐，复盘帖比赛后发布会还及时。", star: 5, color: "bg-accent-500" },
  { name: "夜猫瓜友", role: "指路小能手", content: "新瓜开张总有一群人一起围观，评论区的补充常常比原帖还精彩，氛围真的很友好。", star: 5, color: "bg-secondary-500" },
  { name: "屏幕常亮君", role: "围观 300+ 天", content: "分类清晰，入口明确，想看的瓜总能第一时间找到。催更真的有用，同学们回复很勤快。", star: 4, color: "bg-primary-400" },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "吃瓜直播是什么平台？",
    answer:
      "吃瓜直播是一个面向围观群众的社区内容平台，把热门事件按分类和关键词整理成清晰入口，提供脉络时间线、催更与蹲后续提醒，帮助大家跟紧事件进展、不错过精彩片段。",
  },
  {
    question: "如何快速找到一个想围观的事件？",
    answer:
      "你可以在顶部导航按分类浏览，也可以直接使用站内搜索输入关键词或事件名。热门事件通常会在今日热榜置顶，从那里进入最快、最不容易走错路。",
  },
  {
    question: "「蹲后续」和「催更」是怎么运作的？",
    answer:
      "蹲后续指收藏一个仍在更新的事件帖子，方便随时回来查看脉络；催更则是向整理同学表达想尽快看到下一步进展的意愿。关注的帖子有新更新时，会收到提醒。",
  },
  {
    question: "关注的事件会一直更新下去吗？",
    answer:
      "只要事件仍在发酵、且有新的可靠进展，围观帖就会持续补充脉络。当事件阶段性告一段落时，帖子会标记为「已完结」，你可以放心回头补课。",
  },
  {
    question: "在评论区围观需要注意什么？",
    answer:
      "希望大家文明围观、理性发言，不发布未经证实的猜测或攻击性言论。良好氛围需要大家一起维护，热闹之余也要守住分寸。",
  },
  {
    question: "如何及时收到后续更新的提醒？",
    answer:
      "在下方订阅留下你的常用邮箱，新开的瓜、重要进展与加更通知都会第一时间推送给你，真正实现「带带不迷路」。",
  },
];

export const navLinks = [
  { key: "hot", label: "今日热榜", icon: "ri-fire-line" },
  { key: "board", label: "围观广场", icon: "ri-community-line" },
  { key: "category", label: "瓜田分类", icon: "ri-grid-line" },
  { key: "guide", label: "围观指南", icon: "ri-compass-line" },
  { key: "story", label: "瓜友口碑", icon: "ri-chat-3-line" },
  { key: "faq", label: "常见问题", icon: "ri-question-line" },
];